export default __webpack_public_path__ + "static/agency_krf-37151c592d2249d9c4ae57a4b68c06e5.jpg";